<app-toolbar>
  <div class="right">
    <app-button label="Add all Amber and Red issues" icon="mdi mdi-plus" (click)="addAllRedAndAmber()" />
    <app-button label="Add all Red issues" icon="mdi mdi-plus" (click)="addAllRed()" [isMuted]="!hasRedIssues()" />
    <i class="mdi mdi-circle-small divider"></i>
    <app-button label="Add {{ issuesSelected() }} selected" icon="mdi mdi-plus" (click)="addSelected()" />
  </div>
</app-toolbar>

<table class="table table-hover">
  <thead>
    <tr>
      <th></th>
      <th></th>
      <th>Asset</th>
      <th>Issue</th>
    </tr>
  </thead>
  <tbody>
    @for (issue of issues(); track issue.asset_id) {
      <tr (click)="issueClick(issue)" [class.selected]="issue.selected">
        <td><i class="mdi" [class.mdi-checkbox-marked-outline]="issue.selected" [class.mdi-checkbox-blank-outline]="!issue.selected"></i></td>
        <td class="rag rag-{{ issue.rag }}"></td>
        <td>{{ issue.asset_title }}</td>
        <td>{{ issue.annotation }}</td>
      </tr>
    }
  </tbody>
</table>

<footer class="text-right">
  <i>Click rows to add/remove as an issue</i>
</footer>
